const lengthToTimeMap = {
    "Burst": 7,
    "Short": 15,
    "Medium": 30,
    "Long": 45,
};

export { lengthToTimeMap };
